import { Outlet, createFileRoute, notFound } from '@tanstack/react-router'

import { LoadingIndicator } from '@/core/components/LoadingIndicator'
import { FEATURE_USER_GROUPS } from '@/core/constants/features'
import { userGroupQueries } from '@/http/api/usersGroups'
import { UsersGroupsList } from '@/users/components/UsersGroupsList/UsersGroupsList'

export const Route = createFileRoute(
  '/company/_management/users/$userId/user-groups',
)({
  beforeLoad: ({ context: { user } }) => {
    if (!user?.features.includes(FEATURE_USER_GROUPS)) {
      throw notFound()
    }
  },
  loader: ({ context: { queryClient }, params }) =>
    queryClient.ensureInfiniteQueryData(
      userGroupQueries.infiniteList({
        members_ids: [params.userId],
        sort_by: 'user_group_name',
        sort_order: 'asc',
      }),
    ),
  component: RouteComponent,
  pendingComponent: LoadingIndicator,
})

function RouteComponent() {
  return (
    <>
      <UsersGroupsList />
      <Outlet />
    </>
  )
}
